module.exports = __webpack_public_path__ + "img/reserved-map-thumb.1c456d9e.png";